import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

const DollarInput = ({ label, value, onChange, disabled, min, max, testid }) => (
  <div>
    <Label className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground">{label}</Label>
    <div className="relative mt-2">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground font-mono">$</span>
      <Input type="number" min={min} max={max} step="0.01" value={value} disabled={disabled}
        onChange={(e) => onChange(e.target.value)} data-testid={testid}
        className="pl-7 bg-background border-border rounded-sm font-mono focus-visible:ring-[#007AFF]" />
    </div>
  </div>
);

export const AutoRefillCard = ({
  enabled, setEnabled, threshold, setThreshold, refillAmount, setRefillAmount,
  hasSavedCard, saving, onSave,
}) => (
  <div className="border border-border bg-[#0A0A0A] rounded-sm p-6 space-y-4">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <RefreshCw className="w-4 h-4 text-[#007AFF]" />
        <h2 className="font-heading text-lg font-black tracking-tight">Auto-refill</h2>
      </div>
      <Switch checked={enabled} onCheckedChange={setEnabled} data-testid="autorefill-toggle" />
    </div>
    <p className="text-xs text-muted-foreground">
      When your balance drops below the trigger level, we automatically charge your saved card for the
      refill amount so the call line never stops working.
    </p>
    <div className="grid grid-cols-2 gap-3">
      <DollarInput label="Trigger level" value={threshold} onChange={setThreshold}
        disabled={!enabled} min="0" max="100" testid="autorefill-threshold-input" />
      <DollarInput label="Refill amount" value={refillAmount} onChange={setRefillAmount}
        disabled={!enabled} min="5" max="500" testid="autorefill-amount-input" />
    </div>
    {hasSavedCard === false && (
      <p className="text-xs text-amber-400" data-testid="no-saved-card-hint">
        No saved card yet — complete one purchase and your card will be saved for auto-refill.
      </p>
    )}
    <Button variant="outline" onClick={onSave} disabled={saving} data-testid="autorefill-save-btn"
      className="rounded-sm border-border gap-2 text-xs w-full">
      {saving ? "Saving…" : "Save auto-refill settings"}
    </Button>
  </div>
);
